import { BaseService } from './base-service';

class LeadsService extends BaseService {
  /**
   *  销售线索--刷新线索
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof LeadsService
   */
  refreshData(data) {
    return this.request({
      method: 'get',
      url: `/clue/refresh`,
      params: data
    });
  }
  /**
   *  销售线索--线索查询筛选列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param  {integer} params.conditions
   * @returns
   * @memberof LeadsService
   */
  getClueList(data, params) {
    return this.request({
      method: 'post',
      url: `/clue/list`,
      data,
      params
    });
  }
  /**
   *  销售线索--根据主键查询线索--动态记录
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param  {integer} params.conditions
   * @returns
   * @memberof LeadsService
   */
  getClue(params) {
    return this.request({
      method: 'get',
      url: `/clue/get`,
      params
    });
  }
  /**
   *  销售线索--线索详情--分享消息卡片
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.clueId
   * @returns
   * @memberof LeadsService
   */
  clueShareCareMessage(data) {
    return this.request({
      method: 'post',
      url: `/clue/clueShareCareMessage`,
      data
    });
  }
  /********************************
   * 线索转化为客户或商机
   ********************************/
  /**
   *  转化选择已有客户，客户下拉列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof LeadsService
   */
  relatedCustomList(params) {
    return this.request({
      method: 'get',
      url: `/entity/transform/relatedCustomList`,
      params
    });
  }
  /**
   *  根据主键查询线索 mysqlTaskId
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof LeadsService
   */
  getMsqlTaskId(params) {
    return this.request({
      method: 'get',
      url: `/clue/msqlTaskId`,
      params
    });
  }
  /**
   *  线索详情--获取分配记录数据
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof LeadsService
   */
  getTransferRecord(data) {
    return this.request({
      method: 'post',
      url: `/transfer/record`,
      data
    });
  }
  /**
   *  线索作废
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof LeadsService
   */
  clueDelete(data) {
    return this.request({
      method: 'POST',
      url: `/clue/abandon`,
      data
    });
  }
  /**
   *  获取线索转移人归属线索池
   *
   * @author zhaolun
   * @param  {Object} data
   * @returns
   * @memberof LeadsService
   */
  getClueByUser(params) {
    return this.request({
      method: 'GET',
      url: `/pool/clue/user`,
      params
    });
  }
  /**
   *  线索退回
   *
   * @author Zhaolun
   * @param  {Object} params
   * @returns
   * @memberof LeadsService
   */
  clueBack(data) {
    return this.request({
      method: 'POST',
      url: `/pool/clue/backPool`,
      data
    });
  }
  /**
   *  线索退回检查
   *
   * @author Zhaolun
   * @param  {Object} params
   * @returns
   * @memberof LeadsService
   */
  clueBackCheck(data) {
    return this.request({
      method: 'POST',
      url: `/pool/clue/backPoolCheck`,
      data
    });
  }

  /**
   * @description: 线索名称字段唯一性检查
   * @param {*} data
   * @return {*}
   * @author: 纪楠楠 jinannan@qfei.cn
   */
  clueCheckFieldRepeat(data) {
    return this.request({
      method: 'post',
      url: `/clue/checkFieldRepeat`,
      data
    });
  }
  /**
   * @description: 外呼列表查询
   * @param {*} data
   * @return {*}
   * @author: qsj
   */
  getCallList() {
    return this.request({
      method: 'get',
      url: `/sysOutBound/getBoundList`
    });
  }

  /**
   * @description: 切换外呼
   * @param {*} data
   * @return {*}
   * @author: qsj
   */
  switchCall(data) {
    return this.request({
      method: 'post',
      url: `/sysOutBound/alterBoundRelation`,
      data
    });
  }
}

export const leadsService = new LeadsService();
